export const SELECTED_ANSWER_DELETED = "SelectedAnswerDeleted";
export const NO_ROUTABLE_ANSWER_ON_PAGE = "NoRoutableAnswerOnPage";
export const DEFAULT_ROUTING = "DefaultRouting";
export const DEFAULT_SKIP_CONDITION = "DefaultSkipCondition";
